import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 20px;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Header = styled.div`
    display: flex;
`;

export const BackArrowIcon = styled.div`
    display: flex;
`;

export const SelectModelText = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
    margin-top: 20px;
`;

export const SelectModelDropdown = styled.div`
    margin-top: 24px;
    padding-bottom: 50px;
`;

export const SearchInput = styled.input`
    width: 100%;
    background: #ffffff;
    border: 1px solid #040222;
    border-radius: 8px;
    padding: 10px;
`;
